<template>
    <el-form-item
        ref="elFormItemRef"
        :rules="rules"
        :prop="prop"
        :label-width="labelWidth"
        :required="required"
        class="base-form-item"
        :data-test="`form-item-${prop}`"
        :data-testid="`form-item-${prop}`"
        v-bind="$attrs"
    >
        <template
            v-if="label"
            #label
        >
            <RedesignFormLabel
                v-if="showLabel"
                :label="label ? `${label}`: undefined"
                :icon="icon"
                :required="isRequired"
                :info-text="infoText"
                :info-tooltip-width="infoTooltipWidth"
            >
                <template
                    v-if="$slots['label-action']"
                    #label-action
                >
                    <slot name="label-action" />
                </template>
                <template
                    v-if="$slots['info-text']"
                    #info-text
                >
                    <slot name="info-text" />
                </template>
            </RedesignFormLabel>
        </template>
        <slot />
    </el-form-item>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { FormItem as ElFormItem } from 'element-ui'
import RedesignFormLabel from '@/components/RedesignBaseComponents/Form/RedesignFormLabel.vue'
import { TranslateResult } from 'vue-i18n'

interface IFIProps {
    required?: boolean
    label?: string | TranslateResult
    icon?: string
    error?: string
    infoText?: string | TranslateResult
    labelWidth?: string
    infoTooltipWidth?: string | number
    rules?: Array<object>
    prop?: string | Array<string>
    size?: 'medium' | 'small' | 'mini'
}

const props = withDefaults(defineProps<IFIProps>(), {
    required: false,
    label: '',
    icon: '',
    infoText: '',
    labelWidth: 'auto',
    size: 'small',
    infoTooltipWidth: '',
    error: undefined,
    rules: () => [],
    prop: undefined
})

/* Computed */
const showLabel = computed(() => {
    return props.label || props.icon || props.infoText
})

const isRequired = computed(() => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (props.required || props.rules.some((rule: any) => rule?.required === true))
})
</script>

<style lang="scss">
    .base-form-item {
        .el-form-item__label {
            padding: 0 0 8px !important;
        }
    }
</style>
